import { makeStyles } from '@material-ui/core';

//temporary hook (made to collect "make styles" and se which are reusable. 
const useDevicelogStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  grid: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
}));

export default useDevicelogStyles;